/**
 * 日付ユーティリティ
 * 日付のフォーマット、パース、計算などの共通処理
 */

/**
 * 現在の日時をISO 8601形式の文字列で取得
 * @returns ISO 8601形式の日時文字列（例: "2024-01-15T10:30:45.123Z"）
 */
export function getCurrentISOString(): string {
  return new Date().toISOString();
}

/**
 * 現在の日付をYYYY-MM-DD形式で取得
 * @returns YYYY-MM-DD形式の日付文字列（例: "2024-01-15"）
 */
export function getCurrentDateString(): string {
  return new Date().toISOString().split('T')[0];
}
